import fetch from './fetch'

class ConfigurationApi {
	public getConfigurationList(form: any) {
		return fetch({
			url: '/injury/resource/setting/manage/list',
			method: 'post',
			data: form,
		})
	}

	public updateConfiguration(form: any) {
		return fetch({
			url: '/injury/resource/setting/manage/update',
			method: 'post',
			data: form,
		})
	}

	public getHolidayList(form: any) {
		return fetch({
			url: '/injury/holiday/list',
			method: 'post',
			data: form,
		})
	}

	public holidayImport(form: any) {
		return fetch({
			url: '/injury/holiday/import',
			method: 'post',
			data: form,
		})
	}

	public settlementImport(form: any) {
		return fetch({
			url: '/injury/poi/import',
			method: 'post',
			data: form,
		})
	}

	public getSettlementList(form: any) {
		return fetch({
			url: '/injury/poi/list',
			method: 'post',
			data: form,
		})
	}

	public settlementExport() {
		return fetch({
			url: '/injury/poi/export',
			method: 'post',
			responseType: 'blob',
		})
	}
}

export default new ConfigurationApi()
